<template>
  <div id="formulario-solicitacao">
    <el-row>
      <el-col
        :span="12"
        style="border-right: 1px solid #EEEEEE; padding-right: 25px;"
      >
        <TemplateStepFormularioMultiplo
          v-if="isMultiplo"
          :data="data"
          :idFuncionalidade="idFuncionalidade"
          :step="step"
          :titulo="titulo"
          :step-count="stepCount"
          :step-end="stepEnd"
          :beneficiarioSelecionado="beneficiarioSelecionado"
          @proximo="proximo"
          style="margin-top: 20px"
        />
        <TemplateStepFormularioUnico
          v-else
          :data="data"
          :idFuncionalidade="idFuncionalidade"
          :step="step"
          :titulo="titulo"
          :step-count="stepCount"
          :step-end="stepEnd"
          :beneficiarioSelecionado="beneficiarioSelecionado"
          @proximo="proximo"
          style="margin-top: 20px"
        />
      </el-col>
      <el-col
        :span="12"
      >
        <div
          style="padding-left: 25px;"
          v-html="step.instrucoes"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import TemplateStepFormularioUnico from '@/components/TemplateSolicitacao/steps/TemplateStepFormularioUnico'
import TemplateStepFormularioMultiplo from '@/components/TemplateSolicitacao/steps/TemplateStepFormularioMultiplo'

export default {
  name: 'TemplateStepFormulario',
  components: { TemplateStepFormularioMultiplo, TemplateStepFormularioUnico },
  props: {
    step: {
      type: Object
    },
    titulo: {
      type: String
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    data: {},
    beneficiarioSelecionado: {
      type: Object,
      default: undefined
    },
    stepCount: {
      type: [Number, String],
      default: 1
    },
    stepEnd: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      form: null,
      internalLoading: true
    }
  },
  computed: {
    isMultiplo () {
      return !!this.step.formulario.entradasMultiplas &&
        this.step.formulario.entradasMultiplas > 0
    }
  },
  methods: {
    async proximo (payloadStep) {
      this.$emit('proximo', payloadStep)
    }
  }
}
</script>
<style scoped>
</style>
